var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',_vm._l((_vm.fileList),function(item2,idx){return _c('div',{key:idx,staticClass:"d-flex justify-start align-center"},[_c('FileItem',{attrs:{"item":item2}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }